(function () {
  if (window.__tkMarket) return;
  window.__tkMarket = true;

  /* B2B display factor from <meta id="tk-b2b-meta"> */
  (function () {
    var m = document.getElementById('tk-b2b-meta');
    var on = m && String(m.getAttribute('content') || '') === '1';
    window.tkB2bFactor = on ? 0.9 : 1;
  })();

  var RECENT_KEY = 'tk-recent-v1';
  var FAV_KEY = 'tk-fav-v1';
  var FREE_SHIP = 250000; /* 2500 TL in cents */
  var MAX_RECENT = 12;
  var MAX_FAV = 60;
  function cssEsc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(String(s));
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }
  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  function moneyFromCents(cents) {
    var factor = (typeof window.tkB2bFactor === 'number' ? window.tkB2bFactor : 1);
    var n = Number(cents) / 100 * factor;
    if (isNaN(n)) return '';
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }
  function moneyFromCentsRaw(cents) {
    var n = Number(cents) / 100;
    if (isNaN(n)) return '';
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function isAdultStr(s) {
    return /fantazi|fantezi|erotik|18\+|seks|jartiyer/i.test(String(s || ''));
  }

  /* ---------- Recently viewed ---------- */
  function trackRecentFromPage() {
    var el = document.getElementById('tk-pdp-track');
    if (!el) return;
    var img = el.getAttribute('data-img') || '';
    if (!img) return;
    var item = {
      handle: el.getAttribute('data-handle'),
      id: el.getAttribute('data-id'),
      title: el.getAttribute('data-title'),
      url: el.getAttribute('data-url'),
      img: img,
      price: el.getAttribute('data-price'),
      priceCents: el.getAttribute('data-price-cents'),
      compare: el.getAttribute('data-compare') || '',
      vid: el.getAttribute('data-vid') || '',
      avail: el.getAttribute('data-avail') === '1',
      adult: el.getAttribute('data-adult') === '1',
      simple: el.getAttribute('data-simple') === '1'
    };
    if (!item.handle) return;
    var list = read(RECENT_KEY).filter(function (x) { return x && x.handle !== item.handle; });
    list.unshift(item);
    write(RECENT_KEY, list.slice(0, MAX_RECENT));
  }

  function cardHtml(p, opts) {
    opts = opts || {};
    if (!p || !p.img) return '';
    var adult = p.adult ? ' v-card--adult' : '';
    var factor = (typeof window.tkB2bFactor === 'number' ? window.tkB2bFactor : 1);
    var price = p.price || (p.priceCents != null ? moneyFromCents(p.priceCents) : '');
    var compare = p.compare ? '<s>' + esc(p.compare) + '</s>' : '';
    if (factor < 1 && p.priceCents != null && p.priceCents !== '' && !p.compare) {
      compare = '<s>' + esc(moneyFromCentsRaw(p.priceCents)) + '</s>';
      price = moneyFromCents(p.priceCents);
    }
    var on = isFav(p.handle) ? ' is-on' : '';
    var actions = opts.noActions ? '' :
      '<div class="v-card__actions">' +
      '<button type="button" class="v-card__fav' + on + '" data-tk-fav="' + esc(p.handle) + '" aria-label="Favori">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M12 20s-7-4.4-7-9.2A3.8 3.8 0 0 1 12 7.5a3.8 3.8 0 0 1 7 3.3C19 15.6 12 20 12 20Z"/></svg></button>' +
      '<button type="button" class="v-card__qv" data-tk-qv="' + esc(p.handle) + '" aria-label="Hızlı bakış">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M2.5 12S6.5 5.5 12 5.5 21.5 12 21.5 12 17.5 18.5 12 18.5 2.5 12 2.5 12Z"/><circle cx="12" cy="12" r="2.8"/></svg></button>' +
      '</div>';
    var atc = (p.avail && p.vid) ?
      '<form method="post" action="/cart/add" class="v-card__form" data-tk-ajax-atc>' +
      '<input type="hidden" name="id" value="' + esc(p.vid) + '">' +
      '<input type="hidden" name="quantity" value="1">' +
      '<button type="submit" class="v-card__atc" aria-label="Sepete ekle">+</button></form>' : '';
    var wrapOpen = opts.li ? '<li class="grid__item">' : '';
    var wrapClose = opts.li ? '</li>' : '';
    return wrapOpen + '<article class="v-card' + adult + '" data-tk-card data-handle="' + esc(p.handle) + '" data-id="' + esc(p.id || '') + '" data-title="' + esc(p.title || '') + '" data-url="' + esc(p.url || ('/products/' + p.handle)) + '" data-img="' + esc(p.img || '') + '" data-price="' + esc(price) + '" data-price-cents="' + esc(p.priceCents || '') + '" data-compare="' + esc(p.compare || '') + '" data-vid="' + esc(p.vid || '') + '" data-avail="' + (p.avail === false ? '0' : '1') + '" data-simple="' + (p.simple ? '1' : '0') + '" data-adult="' + (p.adult ? '1' : '0') + '">' +
      actions +
      '<a class="v-card__link" href="' + esc(p.url || ('/products/' + p.handle)) + '">' +
      '<span class="v-card__img"><img src="' + esc(p.img) + '" alt="" loading="lazy" width="400" height="400">' +
      (p.adult ? '<span class="v-card__18">18+</span>' : '') +
      (p.avail === false ? '<span class="v-card__sold">Tükendi</span>' : '') +
      '</span><span class="v-card__name">' + esc(p.title) + '</span></a>' +
      '<div class="v-card__row"><span class="v-card__price">' + compare + '<strong>' + esc(price) + '</strong></span>' + atc + '</div>' +
      '</article>' + wrapClose;
  }

  function paintRecent() {
    var rails = document.querySelectorAll('[data-tk-recent]');
    if (!rails.length) return;
    var list = read(RECENT_KEY).filter(function (p) { return p && p.img && p.avail !== false; });
    var current = document.getElementById('tk-pdp-track');
    var curHandle = current ? current.getAttribute('data-handle') : '';
    if (curHandle) list = list.filter(function (p) { return p.handle !== curHandle; });
    rails.forEach(function (rail) {
      var limit = parseInt(rail.getAttribute('data-limit') || '10', 10);
      var slice = list.slice(0, limit);
      var host = rail.querySelector('[data-tk-recent-list]');
      var empty = rail.querySelector('[data-tk-recent-empty]');
      if (!host) return;
      if (!slice.length) {
        rail.hidden = true;
        if (empty) empty.hidden = false;
        host.innerHTML = '';
        return;
      }
      rail.hidden = false;
      if (empty) empty.hidden = true;
      host.innerHTML = slice.map(function (p) { return cardHtml(p); }).join('');
      syncFavButtons(host);
    });
  }

  /* ---------- Favorites ---------- */
  function isFav(handle) {
    return read(FAV_KEY).some(function (x) { return x && x.handle === handle; });
  }

  function metaFromCard(card, handle) {
    if (!card) return null;
    var img = card.getAttribute('data-img') || '';
    if (!img) {
      var im = card.querySelector('.v-card__img img, img');
      if (im) img = im.getAttribute('src') || im.currentSrc || '';
    }
    return {
      handle: handle,
      id: card.getAttribute('data-id') || '',
      title: card.getAttribute('data-title') || (card.querySelector('.v-card__name') && card.querySelector('.v-card__name').textContent) || handle,
      url: card.getAttribute('data-url') || ('/products/' + handle),
      img: img,
      price: card.getAttribute('data-price') || '',
      priceCents: card.getAttribute('data-price-cents') || '',
      compare: card.getAttribute('data-compare') || '',
      vid: card.getAttribute('data-vid') || '',
      avail: card.getAttribute('data-avail') !== '0',
      adult: card.getAttribute('data-adult') === '1',
      simple: card.getAttribute('data-simple') === '1'
    };
  }

  function fetchProductMeta(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('nf'); return r.json(); })
      .then(function (p) {
        var v = (p.variants && p.variants[0]) || {};
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && typeof img === 'object') img = img.src || '';
        return {
          handle: p.handle || handle,
          id: String(p.id || ''),
          title: p.title || handle,
          url: '/products/' + (p.handle || handle),
          img: img || '',
          price: moneyFromCents(v.price),
          priceCents: String(v.price || ''),
          compare: v.compare_at_price && Number(v.compare_at_price) > Number(v.price) ? moneyFromCents(v.compare_at_price) : '',
          vid: String(v.id || ''),
          avail: v.available !== false,
          adult: isAdultStr((p.type || '') + ' ' + (p.title || '') + ' ' + ((p.tags || []).join(' '))),
          simple: !!(p.variants && p.variants.length === 1)
        };
      });
  }

  function commitFavAdd(item) {
    if (!item || !item.handle) return;
    var list = read(FAV_KEY).filter(function (x) { return !(x && x.handle === item.handle); });
    list.unshift(item);
    write(FAV_KEY, list.slice(0, MAX_FAV));
    syncFavButtons();
    paintFavDrawer();
    updateFavCount();
  }

  function toggleFav(handle, meta, cardEl) {
    if (!handle) return;
    var list = read(FAV_KEY);
    var idx = -1;
    list.forEach(function (x, i) { if (x && x.handle === handle) idx = i; });
    if (idx >= 0) {
      list.splice(idx, 1);
      write(FAV_KEY, list);
      syncFavButtons();
      paintFavDrawer();
      updateFavCount();
      return;
    }
    var item = meta && meta.img ? meta : null;
    if (!item) item = metaFromCard(cardEl, handle);
    if (!item || !item.img) {
      var card = cardEl || document.querySelector('[data-tk-card][data-handle="' + cssEsc(handle) + '"]');
      item = metaFromCard(card, handle) || item;
    }
    if (!item || !item.img) {
      var pdp = document.getElementById('tk-pdp-track');
      if (pdp && pdp.getAttribute('data-handle') === handle) item = metaFromCard(pdp, handle);
    }
    if (item && item.img) {
      commitFavAdd(item);
      return;
    }
    /* never silently fail — fetch product.js then add */
    syncFavButtons();
    document.querySelectorAll('[data-tk-fav="' + cssEsc(handle) + '"]').forEach(function (b) {
      b.classList.add('is-on');
      b.setAttribute('aria-busy', 'true');
    });
    fetchProductMeta(handle).then(function (fetched) {
      if (!fetched.img) throw new Error('noimg');
      commitFavAdd(fetched);
    }).catch(function () {
      /* rollback optimistic UI */
      document.querySelectorAll('[data-tk-fav="' + cssEsc(handle) + '"]').forEach(function (b) {
        b.classList.remove('is-on');
        b.removeAttribute('aria-busy');
        b.setAttribute('aria-label', 'Favorilere ekle');
      });
    }).finally(function () {
      document.querySelectorAll('[data-tk-fav="' + cssEsc(handle) + '"]').forEach(function (b) {
        b.removeAttribute('aria-busy');
      });
    });
  }

  function syncFavButtons(root) {
    (root || document).querySelectorAll('[data-tk-fav]').forEach(function (btn) {
      var h = btn.getAttribute('data-tk-fav');
      var on = isFav(h);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
  }

  function updateFavCount() {
    var n = read(FAV_KEY).length;
    document.querySelectorAll('[data-tk-fav-count]').forEach(function (el) {
      el.textContent = String(n);
      el.hidden = n === 0;
    });
  }

  function paintFavDrawer() {
    var listEl = document.querySelector('[data-tk-fav-list]');
    var empty = document.querySelector('[data-tk-fav-empty]');
    if (!listEl) return;
    var list = read(FAV_KEY).filter(function (p) { return p && p.img; });
    if (!list.length) {
      listEl.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    listEl.innerHTML = list.map(function (p) {
      return '<div class="tk-fav-item">' +
        '<a class="tk-fav-item__img" href="' + esc(p.url || ('/products/' + p.handle)) + '"><img src="' + esc(p.img) + '" alt="" loading="lazy"></a>' +
        '<div class="tk-fav-item__body">' +
        '<a class="tk-fav-item__title" href="' + esc(p.url || ('/products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
        '<div class="tk-fav-item__price">' + esc(p.price || '') + '</div>' +
        '<div class="tk-fav-item__row">' +
        (p.vid ? '<button type="button" class="tk-fav-item__atc" data-tk-fav-atc="' + esc(p.vid) + '">Sepete ekle</button>' : '') +
        '<button type="button" class="tk-fav-item__rm" data-tk-fav="' + esc(p.handle) + '">Kaldır</button>' +
        '</div></div></div>';
    }).join('');
  }

  function openFav() {
    var d = document.getElementById('tk-fav-drawer');
    if (!d) return;
    paintFavDrawer();
    d.classList.add('is-open');
    document.body.classList.add('tk-panel-open');
  }
  function closeFav() {
    var d = document.getElementById('tk-fav-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('tk-panel-open');
  }

  /* ---------- Quick view ---------- */
  function openQv(handle) {
    var modal = document.getElementById('tk-qv');
    if (!modal || !handle) return;
    var body = modal.querySelector('[data-tk-qv-body]');
    body.innerHTML = '<div class="tk-qv__loading">Yükleniyor…</div>';
    modal.classList.add('is-open');
    document.body.classList.add('tk-panel-open');
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.featured_image) {
          body.innerHTML = '<p class="tk-qv__err">Ürün görüntülenemiyor.</p>';
          return;
        }
        var v = (p.variants && p.variants[0]) || {};
        var adult = isAdultStr((p.type || '') + ' ' + (p.title || '') + ' ' + (p.tags || []).join(' '));
        var factor = (typeof window.tkB2bFactor === 'number' ? window.tkB2bFactor : 1);
        var price = moneyFromCents(v.price);
        var compare = '';
        if (factor < 1) {
          compare = '<s>' + moneyFromCentsRaw(v.price) + '</s>';
        } else if (v.compare_at_price && Number(v.compare_at_price) > Number(v.price)) {
          compare = '<s>' + moneyFromCents(v.compare_at_price) + '</s>';
        }
        var simple = (p.variants || []).length <= 1 && v.available;
        var imgClass = adult ? ' tk-qv__img--adult' : '';
        body.innerHTML =
          '<div class="tk-qv__grid">' +
          '<div class="tk-qv__media' + imgClass + '"><img src="' + esc(p.featured_image) + '" alt=""></div>' +
          '<div class="tk-qv__info">' +
          (adult ? '<span class="tk-qv__18">18+</span>' : '') +
          '<h2 class="tk-qv__title">' + esc(p.title) + '</h2>' +
          '<div class="tk-qv__price">' + compare + '<strong>' + esc(price) + '</strong></div>' +
          '<div class="tk-qv__actions">' +
          (simple ?
            '<button type="button" class="tk-qv__atc" data-tk-qv-atc="' + esc(v.id) + '">Sepete ekle</button>' :
            '') +
          '<a class="tk-qv__link" href="/products/' + encodeURIComponent(p.handle) + '">Ürüne git</a>' +
          '<button type="button" class="tk-qv__fav' + (isFav(p.handle) ? ' is-on' : '') + '" data-tk-fav="' + esc(p.handle) + '">Favori</button>' +
          '</div></div></div>';
        /* stash for fav */
        var cardMeta = {
          handle: p.handle,
          id: String(p.id),
          title: p.title,
          url: '/products/' + p.handle,
          img: p.featured_image,
          price: price,
          priceCents: String(v.price),
          compare: v.compare_at_price && Number(v.compare_at_price) > Number(v.price) ? moneyFromCents(v.compare_at_price) : '',
          vid: String(v.id || ''),
          avail: !!v.available,
          adult: adult,
          simple: simple
        };
        body.setAttribute('data-qv-meta', JSON.stringify(cardMeta));
      })
      .catch(function () {
        body.innerHTML = '<p class="tk-qv__err">Ürün yüklenemedi.</p>';
      });
  }

  function closeQv() {
    var modal = document.getElementById('tk-qv');
    if (!modal) return;
    modal.classList.remove('is-open');
    if (!document.getElementById('tk-fav-drawer') || !document.getElementById('tk-fav-drawer').classList.contains('is-open')) {
      document.body.classList.remove('tk-panel-open');
    }
  }

  /* ---------- Free shipping helper (drawer / page already Liquid; refresh via cart.js sections) ---------- */
  function paintShipBars(totalCents) {
    var left = Math.max(0, FREE_SHIP - totalCents);
    var pct = Math.min(100, Math.round((totalCents / FREE_SHIP) * 100));
    document.querySelectorAll('[data-tk-ship]').forEach(function (box) {
      var bar = box.querySelector('[data-tk-ship-bar]');
      var msg = box.querySelector('[data-tk-ship-msg]');
      if (bar) bar.style.width = pct + '%';
      if (msg) {
        msg.textContent = left <= 0
          ? 'Kargo ücretsiz'
          : 'Ücretsiz kargoya ' + moneyFromCents(left) + ' kaldı';
      }
      box.classList.toggle('is-free', left <= 0);
    });
  }

  /* ---------- AJAX add to cart ---------- */
  function addToCart(vid, qty) {
    qty = qty || 1;
    if (!vid) return Promise.reject();
    var formData = new FormData();
    formData.append('id', String(vid));
    formData.append('quantity', String(qty));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      formData.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
    }
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (state) {
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          try { drawer.renderContents(state); } catch (e) {}
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          paintShipBars(c.total_price || 0);
          var count = document.querySelector('#cart-icon-bubble .tk-head__count');
          if (count && typeof c.item_count !== 'undefined') {
            count.textContent = c.item_count;
            count.classList.toggle('tk-head__count--zero', c.item_count === 0);
          }
        }).catch(function () {});
        return state;
      });
  }

  /* ---------- Scroll top ---------- */
  function initScrollTop() {
    var btn = document.getElementById('tk-top');
    if (!btn) return;
    function sync() {
      btn.classList.toggle('is-show', window.scrollY > 420);
    }
    window.addEventListener('scroll', sync, { passive: true });
    sync();
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- Predictive search polish class ---------- */
  function polishPredictive() {
    document.querySelectorAll('predictive-search').forEach(function (el) {
      el.classList.add('tk-predictive');
    });
  }

  /* ---------- Events ---------- */
  function onClick(e) {
    var fav = e.target.closest('[data-tk-fav]');
    if (fav) {
      e.preventDefault();
      e.stopPropagation();
      var handle = fav.getAttribute('data-tk-fav');
      var meta;
      var qvBody = document.querySelector('[data-tk-qv-body][data-qv-meta]');
      if (qvBody && qvBody.getAttribute('data-qv-meta')) {
        try {
          var m = JSON.parse(qvBody.getAttribute('data-qv-meta'));
          if (m.handle === handle) meta = m;
        } catch (err) {}
      }
      var cardEl = fav.closest('[data-tk-card]');
      toggleFav(handle, meta, cardEl);
      return;
    }

    var qv = e.target.closest('[data-tk-qv]');
    if (qv) {
      e.preventDefault();
      e.stopPropagation();
      openQv(qv.getAttribute('data-tk-qv'));
      return;
    }

    var qvAtc = e.target.closest('[data-tk-qv-atc]');
    if (qvAtc) {
      e.preventDefault();
      qvAtc.disabled = true;
      addToCart(qvAtc.getAttribute('data-tk-qv-atc')).finally(function () {
        qvAtc.disabled = false;
        closeQv();
      });
      return;
    }

    var favAtc = e.target.closest('[data-tk-fav-atc]');
    if (favAtc) {
      e.preventDefault();
      favAtc.disabled = true;
      addToCart(favAtc.getAttribute('data-tk-fav-atc')).finally(function () {
        favAtc.disabled = false;
        closeFav();
      });
      return;
    }

    if (e.target.closest('[data-tk-fav-open]')) {
      e.preventDefault();
      openFav();
      return;
    }
    if (e.target.closest('[data-tk-fav-close]')) {
      e.preventDefault();
      closeFav();
      return;
    }
    if (e.target.closest('[data-tk-qv-close]')) {
      e.preventDefault();
      closeQv();
      return;
    }
  }

  function onSubmit(e) {
    var form = e.target.closest('form[data-tk-ajax-atc]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    if (!id) return;
    var btn = form.querySelector('button');
    if (btn) btn.disabled = true;
    addToCart(id.value).finally(function () { if (btn) btn.disabled = false; });
  }

  document.addEventListener('click', onClick);
  document.addEventListener('submit', onSubmit);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeQv(); closeFav(); }
  });

  document.addEventListener('DOMContentLoaded', function () {
    trackRecentFromPage();
    paintRecent();
    syncFavButtons();
    updateFavCount();
    paintFavDrawer();
    initScrollTop();
    polishPredictive();
    paintShipBars(window.__tkCartTotal || 0);
  });

  /* expose */
  window.tkMarket = {
    openFav: openFav,
    closeFav: closeFav,
    openQv: openQv,
    toggleFav: toggleFav,
    paintRecent: paintRecent,
    syncFavButtons: syncFavButtons
  };
})();
